const normalizeThreadPinned = (thread = {}) => {
  return Boolean(thread?.pinned || thread?.pinnedAt);
};

export default normalizeThreadPinned;
